/**
 * @generated SignedSource<<c09d0091f169378048d9817d4dd25c84>>
 * @relayHash 31080e5e62511dde6e8d333bb5ca57b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 86bd60ec9265df62e6ca865576da70af9f998a694aceb05853fefdf610859337

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type collectionTrialModalQuery$variables = {
  collectionEntitlementId: string;
};
export type collectionTrialModalQuery$data = {
  readonly ccp: {
    readonly entitlementV2: {
      readonly " $fragmentSpreads": FragmentRefs<"teamworkCollectionTrialModalFragment">;
    } | null;
  } | null;
};
export type collectionTrialModalQuery = {
  response: collectionTrialModalQuery$data;
  variables: collectionTrialModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "collectionEntitlementId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "collectionEntitlementId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "collectionTrialModalQuery",
    "selections": [
      {
        "concreteType": "CcpQueryApi",
        "kind": "LinkedField",
        "name": "ccp",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "CcpEntitlement",
            "kind": "LinkedField",
            "name": "entitlementV2",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "teamworkCollectionTrialModalFragment"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "collectionTrialModalQuery",
    "selections": [
      {
        "concreteType": "CcpQueryApi",
        "kind": "LinkedField",
        "name": "ccp",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "CcpEntitlement",
            "kind": "LinkedField",
            "name": "entitlementV2",
            "plural": false,
            "selections": [
              {
                "concreteType": "CcpOffering",
                "kind": "LinkedField",
                "name": "offering",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ]
              },
              {
                "concreteType": "CcpEntitlementExperienceCapabilities",
                "kind": "LinkedField",
                "name": "experienceCapabilities",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "CcpManageEntitlementExperienceCapability",
                    "kind": "LinkedField",
                    "name": "manageEntitlement",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "experienceUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isAvailableToUser"
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "licensedUsers",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "chargeElement",
                    "value": "user"
                  }
                ],
                "kind": "ScalarField",
                "name": "latestUsageForChargeElement",
                "storageKey": "latestUsageForChargeElement(chargeElement:\"user\")"
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "relationshipTypes",
                    "value": [
                      "COLLECTION"
                    ]
                  }
                ],
                "concreteType": "CcpEntitlementRelationship",
                "kind": "LinkedField",
                "name": "relatesToEntitlements",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "relationshipType"
                  },
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CcpOffering",
                        "kind": "LinkedField",
                        "name": "offering",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "productKey"
                          },
                          (v3/*: any*/)
                        ]
                      },
                      (v3/*: any*/)
                    ]
                  }
                ],
                "storageKey": "relatesToEntitlements(relationshipTypes:[\"COLLECTION\"])"
              },
              {
                "concreteType": "CcpEntitlementTemplate",
                "kind": "LinkedField",
                "name": "entitlementTemplate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "CcpEntitlementTemplateUserUsageInclusions",
                    "kind": "LinkedField",
                    "name": "userUsageInclusions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "references"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "data"
                  },
                  (v3/*: any*/)
                ]
              },
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "86bd60ec9265df62e6ca865576da70af9f998a694aceb05853fefdf610859337",
    "metadata": {},
    "name": "collectionTrialModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "099e27776796344223da9c18362c93ad";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
